interface CallToActionTranslations {
  en: {
    transformGarden: {
      title: string;
      description: string;
      linkText: string;
    };
    joinClients: {
      title: string;
      description: string;
      linkText: string;
    };
    questions: {
      title: string;
      description: string;
      linkText: string;
    };
  };
  cy: {
    transformGarden: {
      title: string;
      description: string;
      linkText: string;
    };
    joinClients: {
      title: string;
      description: string;
      linkText: string;
    };
    questions: {
      title: string;
      description: string;
      linkText: string;
    };
  };
}

export const callToActionTranslations: CallToActionTranslations = {
  en: {
    transformGarden: {
      title: "Ready to Transform Your Garden?",
      description: "Don't wait to create your dream outdoor space. Contact me today for a free, no-obligation consultation and let's bring your vision to life.",
      linkText: "Get Your Free Consultation"
    },
    joinClients: {
      title: "Join My Happy Clients!",
      description: "Experience the professional, reliable, and high-quality gardening services my clients rave about. Your satisfaction is my priority.",
      linkText: "Book Your Service Today"
    },
    questions: {
      title: "Still Have Questions?",
      description: "We're here to provide clear answers and personalized solutions for all your gardening needs. Reach out to us directly.",
      linkText: "Ask a Question"
    }
  },
  cy: {
    transformGarden: {
      title: "Barod i Drawsnewid Eich Gardd?",
      description: "Peidiwch â aros i greu eich lle awyr agored delfrydol. Cysylltwch â mi heddiw am ymgynghoriad am ddim, heb rwymedigaeth a gadewch i ni roi eich gweledigaeth yn fyw.",
      linkText: "Cael Eich Ymgynghoriad Am Ddim"
    },
    joinClients: {
      title: "Ymunwch â Fy Nghleientiaid Hapus!",
      description: "Profiwch y gwasanaethau garddio proffesiynol, dibynadwy ac o ansawdd uchel y mae fy nghleientiaid yn eu canmol. Eich boddhad yw fy mlaenoriaeth.",
      linkText: "Archebu Eich Gwasanaeth Heddiw"
    },
    questions: {
      title: "Dal â Chwestiynau?",
      description: "Rwy'n yma i ddarparu atebion clir ac atebion personol ar gyfer eich holl anghenion garddio. Cysylltwch â mi'n uniongyrchol.",
      linkText: "Gofyn Cwestiwn"
    }
  }
}; 